import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import styled from "styled-components";
import GlobalStyles from "./styles/GlobalStyles";
import Header from "./components/Header";
import Hero from "./components/Hero";
import LegalDisclaimer from "./components/LegalDisclaimer";
import AboutEnhanced from "./components/AboutEnhanced";
import ISOCertificates from "./components/ISOCertificates";
import Footer from "./components/Footer";
import About from "./pages/About";
import ContactUs from "./pages/ContactUs";
//import Events from "./pages/Events";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Sitemap from "./pages/Sitemap";
import LeaseDeed from "./pages/services/LeaseDeed";
import StampPaperNotary from "./pages/services/StampPaperNotary";
import PropertyRegistry from "./pages/services/PropertyRegistry";
import ContractDrafting from "./pages/services/ContractDrafting";
import RelationshipCertificate from "./pages/services/RelationshipCertificate";
import CourtMarriage from "./pages/services/CourtMarriage";
import LegalNotices from "./pages/services/LegalNotices";
import FranchiseAgreement from "./pages/services/FranchiseAgreement";
import CertifiedCopy from "./pages/services/CertifiedCopy";
import PrivateLimitedCompany from "./pages/services/PrivateLimitedCompany";
import PublicLimitedCompany from "./pages/services/PublicLimitedCompany";
import OpcAndProprietorship from "./pages/services/OpcAndProprietorship";
import NbfcRegistration from "./pages/services/NbfcRegistration";
import SocietyAndTrust from "./pages/services/SocietyAndTrust";
import GstRegistrationAndReturns from "./pages/services/GstRegistrationAndReturns";
import ItrFiling from "./pages/services/ItrFiling";
import AnnualFilingAndRoc from "./pages/services/AnnualFilingAndRoc";
import BookKeepingAndAudit from "./pages/services/BookKeepingAndAudit";
import TrademarkRegistration from "./pages/services/TrademarkRegistration";
import CopyrightRegistration from "./pages/services/CopyrightRegistration";
import PatentFiling from "./pages/services/PatentFiling";
import FssaiLicense from "./pages/services/FssaiLicense";
import TradeLicense from "./pages/services/TradeLicense";
import ImportExportCode from "./pages/services/ImportExportCode";
import IsoCertification from "./pages/services/IsoCertification";
import LegalMetrology from "./pages/services/LegalMetrology";
import EprCertificate from "./pages/services/EprCertificate";
import BisHallmark from "./pages/services/BisHallmark";
import PsaraLicense from "./pages/services/PsaraLicense";
import WpcVno from "./pages/services/WpcVno";
import BpoLicense from "./pages/services/BpoLicense";
import ApedaRegistration from "./pages/services/ApedaRegistration";
import ImportMedicalDevices from "./pages/services/ImportMedicalDevices";
import BailMatters from "./pages/services/BailMatters";
import CyberFraud from "./pages/services/CyberFraud";
import CivilAndCriminal from "./pages/services/CivilAndCriminal";
import Arbitration from "./pages/services/Arbitration";
import ConsumerComplaint from "./pages/services/ConsumerComplaint";
import CriminalCases from "./pages/services/CriminalCases";
import DocumentAttestation from "./pages/services/DocumentAttestation";
import LitigationServices from "./pages/services/LitigationServices";
import Notarization from "./pages/services/Notarization";
import LoanProjectReports from "./pages/services/LoanProjectReports";
import WhatsAppFloatingButton from './components/WhatsAppFloatingButton';
import ChattyAssistant from './components/PiriyaAssistant';
import ShiftingRegisteredOffice from "./pages/services/ShiftingRegisteredOffice";
import WebsiteDevelopment from "./pages/services/WebsiteDevelopment";
import EcommerceDevelopment from "./pages/services/EcommerceDevelopment";
import Section19 from "./pages/services/section-19-legal-metrology";
import GemRegistration from "./pages/services/GemRegistration";
import { useEffect, useState } from "react";
import TestimonialsSection from "./components/TestimonialSection";


// Main App Container
const AppContainer = styled.div`
  min-height: 100vh;
  overflow-x: hidden;
`;

// Services Section
const ServicesSection = styled.section`
  padding: 8rem 0 7rem;
  background: #080D1A;
  position: relative;
  overflow: hidden;
  font-family: 'Outfit', sans-serif;

  &::before {
  content: "";
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(201,168,76,0.3) 15%,
    rgba(201,168,76,0.85) 35%,
    #C9A84C 50%,
    rgba(201,168,76,0.85) 65%,
    rgba(201,168,76,0.3) 85%,
    transparent 100%
  );
  z-index: 10;
  pointer-events: none;
}
  &::after {
    content: "";
    position: absolute;
    width: 600px; height: 600px;
    bottom: -200px; right: -150px;
    background: radial-gradient(circle, rgba(30,60,120,0.14) 0%, transparent 70%);
    pointer-events: none;
  }

  @media (max-width: 768px) {
    padding: 5rem 0 4rem;
  }
`;

const ServicesContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 2.5rem;
  position: relative;
  z-index: 2;

  .section-header {
    text-align: center;
    max-width: 680px;
    margin: 0 auto 5rem;
    &.center { text-align: center; }
  }

  .section-tag {
    display: inline-flex;
    align-items: center;
    gap: 0.55rem;
    font-size: 0.68rem;
    font-weight: 600;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: #C9A84C;
    border: 1px solid rgba(201,168,76,0.22);
    background: rgba(201,168,76,0.10);
    padding: 0.55rem 1.1rem;
    border-radius: 2px;
    margin-bottom: 1.6rem;
    font-family: 'Outfit', sans-serif;

    &::before {
      content: "";
      width: 18px; height: 1px;
      background: #C9A84C;
      display: inline-block;
    }
  }

  .section-title {
    font-family: 'Cormorant Garamond', Georgia, serif;
    font-size: clamp(2.4rem, 4vw, 3.8rem);
    font-weight: 400;
    line-height: 1.08;
    color: #F0E9D6;
    margin-bottom: 1.4rem;
    letter-spacing: -0.3px;
  }

  .text-highlight {
    font-style: italic;
    font-weight: 300;
    color: #E2C47A;
  }

  .section-description {
    font-size: 0.96rem;
    font-weight: 300;
    line-height: 1.9;
    color: #A8B4C8;
    font-family: 'Outfit', sans-serif;
  }

  @media (max-width: 768px) {
    padding: 0 1.25rem;
  }
`;

const ServicesShowcase = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.4rem;
  margin-bottom: 1.4rem;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const ServiceCard = styled.div`
  display: flex;
  flex-direction: column;
  background: #0F1624;
  border: 1px solid rgba(201,168,76,0.12);
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  transition: border-color 0.4s ease, transform 0.4s ease;

  &::before {
    content: "";
    position: absolute;
    top: 0; left: 0; right: 0; height: 1px;
    background: linear-gradient(90deg, transparent, #C9A84C, transparent);
    opacity: 0;
    transition: opacity 0.4s ease;
    z-index: 2;
  }

  &:hover {
    transform: translateY(-6px);
    border-color: rgba(201,168,76,0.35);
  }

  &:hover::before {
    opacity: 1;
  }

  &.featured {
    border-color: rgba(201,168,76,0.28);

    &::after {
      content: "Most Popular";
      position: absolute;
      top: 1rem;
      right: 1rem;
      background: #C9A84C;
      color: #080D1A;
      padding: 0.32rem 0.8rem;
      border-radius: 2px;
      font-size: 0.62rem;
      font-weight: 700;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      z-index: 3;
      font-family: 'Outfit', sans-serif;
    }
  }
`;

const ServiceImage = styled.div`
  position: relative;
  height: 190px;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.6s ease;
    filter: brightness(0.72) saturate(0.85);
  }

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      to bottom,
      rgba(8,13,26,0.08) 0%,
      rgba(8,13,26,0.55) 100%
    );
  }

  ${ServiceCard}:hover & img {
    transform: scale(1.06);
  }
`;

const ServiceContent = styled.div`
  padding: 1.75rem;
  display: flex;
  flex-direction: column;
  flex: 1;

  h3 {
    font-family: 'Cormorant Garamond', Georgia, serif;
    font-size: 1.5rem;
    font-weight: 500;
    color: #F0E9D6;
    margin-bottom: 0.75rem;
    line-height: 1.2;
  }

  p {
    font-size: 0.875rem;
    font-weight: 300;
    line-height: 1.85;
    color: #A8B4C8;
    margin-bottom: 1.1rem;
    flex: 1;
    font-family: 'Outfit', sans-serif;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0 0 1.4rem;

    li {
      display: flex;
      align-items: center;
      gap: 0.6rem;
      font-size: 0.8rem;
      font-weight: 400;
      color: #A8B4C8;
      margin-bottom: 0.45rem;
      font-family: 'Outfit', sans-serif;

      i {
        color: #C9A84C;
        font-size: 0.55rem;
        flex-shrink: 0;
      }
    }
  }

  .service-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.72rem;
    font-weight: 600;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #C9A84C;
    text-decoration: none;
    margin-top: auto;
    transition: gap 0.25s ease;
    font-family: 'Outfit', sans-serif;

    i {
      font-size: 0.65rem;
      transition: transform 0.25s ease;
    }

    &:hover {
      gap: 0.8rem;
      text-decoration: none;
      color: #E2C47A;

      i { transform: translateX(3px); }
    }
  }
`;

const ViewAllServices = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.2rem;
  margin-top: 4rem;
  flex-wrap: wrap;

  .view-all-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.7rem;
    background: #C9A84C;
    color: #080D1A;
    padding: 0.95rem 2.2rem;
    border-radius: 2px;
    font-weight: 600;
    font-size: 0.78rem;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    text-decoration: none;
    transition: all 0.35s ease;
    font-family: 'Outfit', sans-serif;
    border: 1px solid #C9A84C;

    i { font-size: 0.72rem; }

    &:hover {
      background: #E2C47A;
      border-color: #E2C47A;
      transform: translateY(-2px);
      box-shadow: 0 8px 28px rgba(201,168,76,0.28);
      text-decoration: none;
      color: #080D1A;
    }
  }
`;

// Practice Areas Section
const PracticeAreasSection = styled.section`
  padding: 7rem 0;

  background: #f8f5f0;

  position: relative;
  overflow: hidden;

  &::before {
    content: "";

    position: absolute;

    width: 600px;
    height: 600px;

    top: -300px;
    right: -200px;

    background:
      radial-gradient(
        circle,
        rgba(184,155,114,0.10),
        transparent 70%
      );

    pointer-events: none;
  }

  /* 1536px+ Ultra Wide */
  @media (min-width: 1536px) {
    padding: 8rem 0;
  }

  /* 1280px */
  @media (max-width: 1280px) {
    padding: 6.5rem 0;
  }

  /* 1024px */
  @media (max-width: 1024px) {
    padding: 5.5rem 0;
  }

  /* 768px */
  @media (max-width: 768px) {
    padding: 4.5rem 0;

    &::before {
      width: 450px;
      height: 450px;
    }
  }

  /* 640px */
  @media (max-width: 640px) {
    padding: 4rem 0;
  }

  /* 480px */
  @media (max-width: 480px) {
    padding: 3.5rem 0;

    &::before {
      width: 350px;
      height: 350px;
      right: -180px;
    }
  }

  /* 320px */
  @media (max-width: 320px) {
    padding: 3rem 0;
  }
`;

const PracticeGrid = styled.div`
  display: grid;

  grid-template-columns: 0.9fr 1.1fr;

  gap: 5rem;

  align-items: start;

  .practice-left-column {
    position: sticky;
    top: 120px;
  }

  /* 1536px+ */
  @media (min-width: 1536px) {
    gap: 7rem;
  }

  /* 1280px */
  @media (max-width: 1280px) {
    gap: 4rem;
  }

  /* 1024px */
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;

    gap: 3rem;

    .practice-left-column {
      position: relative;
      top: 0;
    }
  }

  /* 768px */
  @media (max-width: 768px) {
    gap: 2.5rem;
  }

  /* 640px */
  @media (max-width: 640px) {
    gap: 2rem;
  }

  /* 480px */
  @media (max-width: 480px) {
    gap: 1.5rem;
  }

  /* 320px */
  @media (max-width: 320px) {
    gap: 1.2rem;
  }
`;

const PracticeItem = styled.a`
  display: flex;

  align-items: center;

  justify-content: space-between;

  gap: 1.5rem;

  padding: 2rem 0;

  border-bottom:
    1px solid rgba(17,24,39,0.08);

  text-decoration: none;

  position: relative;

  transition:
    transform 0.35s ease,
    padding-left 0.35s ease;

  &::before {
    content: "";

    position: absolute;

    left: -25px;
    top: 50%;

    transform: translateY(-50%);

    width: 0;
    height: 2px;

    background: #b89b72;

    transition: width 0.35s ease;
  }

  &:hover {
    padding-left: 1rem;
    text-decoration: none;
  }

  &:hover::before {
    width: 40px;
  }

  .practice-left {
    display: flex;
    align-items: center;
    gap: 1.5rem;
  }

  .practice-icon {
    width: 72px;
    height: 72px;

    border-radius: 22px;

    background:
      rgba(184,155,114,0.10);

    display: flex;
    align-items: center;
    justify-content: center;

    transition:
      transform 0.35s ease,
      background 0.35s ease;

    flex-shrink: 0;

    i {
      font-size: 1.4rem;
      color: #8b7355;
    }
  }

  &:hover .practice-icon {
    transform: scale(1.08);

    background:
      rgba(184,155,114,0.18);
  }

  .practice-content {
    h4 {
      font-family:
        "Cormorant Garamond",
        Georgia,
        serif;

      font-size: 2rem;

      font-weight: 500;

      color: #111827;

      margin-bottom: 0.4rem;

      transition: color 0.3s ease;
    }

    p {
      font-size: 0.96rem;

      color: #6b7280;

      line-height: 1.8;

      max-width: 520px;

      margin: 0;

      font-family: "Inter", sans-serif;
    }
  }

  &:hover h4 {
    color: #8b7355;
  }

  .practice-arrow {
    width: 54px;
    height: 54px;

    border-radius: 50%;

    border:
      1px solid rgba(17,24,39,0.08);

    display: flex;
    align-items: center;
    justify-content: center;

    transition:
      transform 0.35s ease,
      background 0.35s ease,
      border 0.35s ease;

    flex-shrink: 0;

    i {
      color: #8b7355;
      font-size: 1rem;
    }
  }

  &:hover .practice-arrow {
    transform: translateX(5px);

    background:
      rgba(184,155,114,0.10);

    border-color:
      rgba(184,155,114,0.20);
  }

  /* 1280px */
  @media (max-width: 1280px) {
    .practice-content h4 {
      font-size: 1.8rem;
    }
  }

  /* 1024px */
  @media (max-width: 1024px) {
    padding: 1.8rem 0;

    .practice-content h4 {
      font-size: 1.7rem;
    }

    .practice-content p {
      max-width: 100%;
    }
  }

  /* 768px */
  @media (max-width: 768px) {
    align-items: flex-start;

    gap: 1.2rem;

    .practice-left {
      align-items: flex-start;
      gap: 1rem;
    }

    .practice-icon {
      width: 64px;
      height: 64px;

      border-radius: 18px;

      i {
        font-size: 1.25rem;
      }
    }

    .practice-content h4 {
      font-size: 1.55rem;
    }

    .practice-content p {
      font-size: 0.92rem;
      line-height: 1.7;
    }

    .practice-arrow {
      width: 48px;
      height: 48px;
    }
  }

  /* 640px */
  @media (max-width: 640px) {
    .practice-content h4 {
      font-size: 1.45rem;
    }

    .practice-content p {
      font-size: 0.9rem;
    }
  }

  /* 480px */
  @media (max-width: 480px) {
    gap: 1rem;

    padding: 1.5rem 0;

    &::before {
      display: none;
    }

    &:hover {
      padding-left: 0;
    }

    .practice-icon {
      width: 56px;
      height: 56px;

      border-radius: 16px;

      i {
        font-size: 1.1rem;
      }
    }

    .practice-content h4 {
      font-size: 1.3rem;
      margin-bottom: 0.3rem;
    }

    .practice-content p {
      font-size: 0.86rem;
      line-height: 1.6;
    }

    .practice-arrow {
      display: none;
    }
  }

  /* 320px */
  @media (max-width: 320px) {
    padding: 1.2rem 0;

    .practice-left {
      gap: 0.8rem;
    }

    .practice-icon {
      width: 50px;
      height: 50px;

      i {
        font-size: 1rem;
      }
    }

    .practice-content h4 {
      font-size: 1.15rem;
    }

    .practice-content p {
      font-size: 0.8rem;
    }
  }
`;


// Contact Section
const ContactSection = styled.section`
  padding: 8rem 0;

  background:
    linear-gradient(
      180deg,
      #F8F5F0 0%,
      #FFFFFF 100%
    );

  position: relative;

  overflow: hidden;

  &::before {
    content: "";

    position: absolute;

    width: 700px;
    height: 700px;

    top: -300px;
    left: -250px;

    background:
      radial-gradient(
        circle,
        rgba(184,155,114,0.10),
        transparent 70%
      );

    pointer-events: none;
  }

  /* 1536px+ */
  @media (min-width: 1536px) {
    padding: 9rem 0;
  }

  /* 1280px */
  @media (max-width: 1280px) {
    padding: 7rem 0;
  }

  /* 1024px */
  @media (max-width: 1024px) {
    padding: 6rem 0;
  }

  /* 768px */
  @media (max-width: 768px) {
    padding: 5rem 0;
  }

  /* 480px */
  @media (max-width: 480px) {
    padding: 4rem 0;
  }

  /* 320px */
  @media (max-width: 320px) {
    padding: 3rem 0;
  }
`;

const ContactContent = styled.div`
  display: grid;

  grid-template-columns: 0.95fr 1.05fr;

  gap: 5rem;

  align-items: start;

  position: relative;

  z-index: 2;

  /* 1536px+ */
  @media (min-width: 1536px) {
    gap: 6rem;
  }

  /* 1280px */
  @media (max-width: 1280px) {
    gap: 4rem;
  }

  /* 1024px */
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;

    gap: 3rem;
  }

  /* 768px */
  @media (max-width: 768px) {
    gap: 2.5rem;
  }

  /* 480px */
  @media (max-width: 480px) {
    gap: 2rem;
  }
`;

const ContactInfo = styled.div`
  .section-header {
    margin-bottom: 3rem;
  }

  .section-title {
    color: #111827;
    font-family:
    "Cormorant Garamond",
    Georgia,
    serif;
  }
  
  

  .section-description {
    color: #64748B;

    line-height: 1.9;

    max-width: 520px;
  }

  .contact-details {
    display: flex;
    flex-direction: column;

    gap: 1.4rem;
  }

  .contact-item {
    display: flex;

    align-items: flex-start;

    gap: 1.2rem;

    padding: 1.4rem;

    background:
      rgba(255,255,255,0.72);

    backdrop-filter: blur(12px);

    border:
      1px solid rgba(15,23,42,0.06);

    border-radius: 22px;

    transition:
      transform 0.35s ease,
      box-shadow 0.35s ease,
      border 0.35s ease;

    &:hover {
      transform: translateY(-5px);

      border-color:
        rgba(184,155,114,0.20);

      box-shadow:
        0 18px 35px rgba(15,23,42,0.06);
    }

    .contact-icon {
      width: 62px;
      height: 62px;

      background:
        #216b72;

      border-radius: 18px;

      display: flex;
      align-items: center;
      justify-content: center;

      flex-shrink: 0;

      box-shadow:
        0 12px 24px rgba(184,155,114,0.22);

      i {
        color: white;
        font-size: 1.2rem;
      }
    }

    .contact-text {

      h4 {
        color: #111827;

        font-size: 1.05rem;

        margin-bottom: 0.45rem;

        font-family:
          "Cormorant Garamond",
          Georgia,
          serif;
      }

      p {
        color: #64748B;

        line-height: 1.8;

        margin: 0;

        font-family: "Inter", sans-serif;
      }
    }
  }

  /* 768px */
  @media (max-width: 768px) {

    .contact-item {
      padding: 1.2rem;

      .contact-icon {
        width: 56px;
        height: 56px;
      }
    }
  }

  /* 480px */
  @media (max-width: 480px) {

    .contact-item {
      border-radius: 18px;

      gap: 1rem;

      .contact-icon {
        width: 50px;
        height: 50px;

        border-radius: 14px;

        i {
          font-size: 1rem;
        }
      }

      .contact-text h4 {
        font-size: 1rem;
      }

      .contact-text p {
        font-size: 0.9rem;
      }
    }
  }

  /* 320px */
  @media (max-width: 320px) {

    .contact-item {
      padding: 1rem;
    }
  }
`;

const ContactForm = styled.div`
  position: relative;

  background:
    rgba(255,255,255,0.78);

  backdrop-filter: blur(18px);

  padding: 3rem;

  border-radius: 32px;

  border:
    1px solid rgba(15,23,42,0.06);

  box-shadow:
    0 24px 60px rgba(15,23,42,0.08);

  overflow: hidden;

  &::before {
    content: "";

    position: absolute;

    width: 350px;
    height: 350px;

    top: -180px;
    right: -140px;

    background:
      radial-gradient(
        circle,
        rgba(184,155,114,0.14),
        transparent 70%
      );

    pointer-events: none;
  }

  h3 {
    color: #111827;

    font-size: 2rem;

    margin-bottom: 1rem;

    text-align: center;

    font-family:
      "Cormorant Garamond",
      Georgia,
      serif;

    font-weight: 500;
  }

  p {
    color: #64748B;

    text-align: center;

    margin-bottom: 2.2rem;

    line-height: 1.8;

    font-family: "Inter", sans-serif;
  }

  .form-grid {
    display: grid;

    grid-template-columns: 1fr 1fr;

    gap: 1.4rem;

    margin-bottom: 1.4rem;

    /* 768px */
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .form-group {
    display: flex;
    flex-direction: column;

    label {
      color: #111827;

      font-weight: 600;

      margin-bottom: 0.6rem;

      font-size: 0.92rem;

      font-family: "Inter", sans-serif;

      .required {
        color: #DC2626;
      }
    }

    .input-wrapper {
      position: relative;

      .input-icon {
        position: absolute;

        left: 1rem;
        top: 50%;

        transform: translateY(-50%);

        color: #216b72;

        font-size: 0.95rem;

        z-index: 2;
      }

      input,
      select,
      textarea {
        width: 100%;

        padding:
          1rem 1rem 1rem 3rem;

        border:
          1px solid rgba(15,23,42,0.08);

        border-radius: 16px;

        font-size: 0.95rem;

        transition: all 0.35s ease;

        background:
          rgba(255,255,255,0.80);

        font-family: "Inter", sans-serif;

        color: #111827;

        &:focus {
          border-color: rgba(184,155,114,0.50);

          background: #ffffff;

          box-shadow:
            0 0 0 4px rgba(184,155,114,0.10);

          outline: none;

          transform: translateY(-2px);
        }

        &::placeholder {
          color: #94A3B8;
        }
      }

      textarea {
        resize: vertical;

        min-height: 140px;

        line-height: 1.7;
      }

      select {
        appearance: none;

        cursor: pointer;
      }
    }
  }

  .submit-btn {
    width: 100%;

    padding: 1.1rem 2rem;

    background:
      linear-gradient(
        135deg,
        #42526B 0%,
        #64748B 100%
      );

    color: #ffffff;

    border: none;

    border-radius: 18px;

    font-size: 1rem;

    font-weight: 600;

    cursor: pointer;

    transition:
      transform 0.35s ease,
      box-shadow 0.35s ease;

    box-shadow:
      0 16px 35px rgba(66,82,107,0.22);

    display: flex;

    align-items: center;
    justify-content: center;

    gap: 0.75rem;

    font-family: "Inter", sans-serif;

    &:hover {
      transform: translateY(-4px);

      box-shadow:
        0 22px 45px rgba(66,82,107,0.30);
    }
  }

  .form-note {
    text-align: center;

    margin-top: 1.4rem;

    font-size: 0.84rem;

    color: #64748B;

    font-family: "Inter", sans-serif;

    i {
      color: #8B7355;

      margin-right: 0.35rem;
    }
  }

  /* 1280px */
  @media (max-width: 1280px) {
    padding: 2.6rem;
  }

  /* 1024px */
  @media (max-width: 1024px) {
    padding: 2.4rem;
  }

  /* 768px */
  @media (max-width: 768px) {
    padding: 2rem;

    border-radius: 26px;

    h3 {
      font-size: 1.7rem;
    }
  }

  /* 640px */
  @media (max-width: 640px) {
    h3 {
      font-size: 1.55rem;
    }
  }

  /* 480px */
  @media (max-width: 480px) {
    padding: 1.5rem;

    border-radius: 22px;

    h3 {
      font-size: 1.35rem;
    }

    p {
      font-size: 0.9rem;
    }

    .submit-btn {
      padding: 1rem;
      border-radius: 14px;
    }
  }

  /* 320px */
  @media (max-width: 320px) {
    padding: 1.2rem;
  }
`;

function App() {

  // Handle form submission
  const handleFormSubmit = (e) => {
    e.preventDefault();

    // Get form data
    const formData = new FormData(e.target);
    const firstName = formData.get("firstName");
    const lastName = formData.get("lastName");
    const email = formData.get("email");
    const phone = formData.get("phone");
    const legalMatter = formData.get("legalMatter");
    const message = formData.get("message");

    // Create WhatsApp message
    const whatsappMessage =
      `*New Consultation Request from Website*\n\n` +
      `*Name:* ${firstName} ${lastName}\n` +
      `*Email:* ${email}\n` +
      `*Phone:* ${phone}\n` +
      `*Legal Matter:* ${legalMatter}\n` +
      `*Message:* ${message}\n\n` +
      `*Submitted from:* Mundra Exim Consultants Website`;

    // WhatsApp number
    const whatsappNumber = "918506874280";
    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

    // Show success message and redirect
    const submitBtn = e.target.querySelector(".submit-btn");
    const originalContent = submitBtn.innerHTML;

    submitBtn.innerHTML =
      '<i class="fas fa-check"></i> Redirecting to WhatsApp...';
    submitBtn.style.background = "#25D366";

    setTimeout(() => {
      window.open(whatsappURL, "_blank");

      // Reset form and button
      e.target.reset();
      submitBtn.innerHTML = originalContent;
      submitBtn.style.background = "";

      alert(
        "Your consultation request has been prepared! Please send the message through WhatsApp to complete your booking.",
      );
    }, 1000);
  };

  const HomePage = () => (

    
    <AppContainer>
      <Header />
      <Hero />
  <LegalDisclaimer />
      {/* <TrustedCompanies /> */}

      {/* Enhanced About Section with Lottie animations */}
      <AboutEnhanced />

      {/* Services Section */}
      <ServicesSection className="services section" id="services">
        <ServicesContainer>
          <div className="section-header center">
            <span className="section-tag">Our Services</span>
            <h2 className="section-title">
              Comprehensive{" "}
              <span className="text-highlight">Legal & Compliance Solutions</span>
            </h2>
            <p className="section-description">
              We offer a full spectrum of legal services designed to meet the
              diverse needs of our clients across various industries and legal
              matters.
            </p>
          </div>

          <ServicesShowcase>
            <ServiceCard
              onClick={() =>
                (window.location.href = "/services/Arbitration")
              }
            >
              <ServiceImage>
                <img
                  src="https://images.unsplash.com/photo-1528740561666-dc2479dc08ab?q=80&w=1200&auto=format&fit=crop"
                  alt="Arbitration"
                />
              </ServiceImage>

              <ServiceContent>
                <h3>Arbitration</h3>

                <p>
                  Strategic Arbitration and dispute resolution services
                  including tribunal representation, enforcement of
                  awards, and settlement negotiations.
                </p>

                <ul>
                  <li>
                    <i className="fas fa-check"></i>
                    Arbitration Notices
                  </li>

                  <li>
                    <i className="fas fa-check"></i>
                    Section 9 & 34 Petitions
                  </li>

                  <li>
                    <i className="fas fa-check"></i>
                    Award Enforcement
                  </li>
                </ul>

                <a href="/services/Arbitration" className="service-btn">
                  Learn More <i className="fas fa-arrow-right"></i>
                </a>
              </ServiceContent>
            </ServiceCard>

            <ServiceCard
              className="featured"
              onClick={() =>
                (window.location.href = "/services/criminal-litigation")
              }
            >
              <ServiceImage>
                <img
                  src="https://images.unsplash.com/photo-1589829545856-d10d557cf95f?q=80&w=1200&auto=format&fit=crop"
                  alt="Criminal Litigation"
                />
              </ServiceImage>

              <ServiceContent>
                <h3>Criminal Litigation</h3>

                <p>
                  Expert criminal defence representation for bail,
                  FIR quashing, financial offences, appeals,
                  and criminal court proceedings.
                </p>

                <ul>
                  <li>
                    <i className="fas fa-check"></i>
                    Bail Applications
                  </li>

                  <li>
                    <i className="fas fa-check"></i>
                    FIR Quashing
                  </li>

                  <li>
                    <i className="fas fa-check"></i>
                    White Collar Crimes
                  </li>
                </ul>

                <a href="/services/criminal-litigation" className="service-btn">
                  Learn More <i className="fas fa-arrow-right"></i>
                </a>
              </ServiceContent>
            </ServiceCard>

            <ServiceCard
              onClick={() =>
                (window.location.href = "/services/cyber-fraud")
              }
            >
              <ServiceImage>
                <img
                  src="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=1200&auto=format&fit=crop"
                  alt="Cyber Crime"
                />
              </ServiceImage>

              <ServiceContent>
                <h3>Cyber Crime</h3>

                <p>
                  Legal assistance for cyber fraud, phishing,
                  hacking, social media harassment, IT compliance,
                  and digital evidence matters.
                </p>

                <ul>
                  <li>
                    <i className="fas fa-check"></i>
                    Cyber Fraud Complaints
                  </li>

                  <li>
                    <i className="fas fa-check"></i>
                    IT Act Compliance
                  </li>

                  <li>
                    <i className="fas fa-check"></i>
                    Social Media Defamation
                  </li>
                </ul>

                <a href="/services/cyber-fraud" className="service-btn">
                  Learn More <i className="fas fa-arrow-right"></i>
                </a>
              </ServiceContent>
            </ServiceCard>

            <ServiceCard
              onClick={() =>
                (window.location.href = "/services/banking-finance")
              }
            >
              <ServiceImage>
                <img
                  src="https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?q=80&w=1200&auto=format&fit=crop"
                  alt="Banking & Finance"
                />
              </ServiceImage>

              <ServiceContent>
                <h3>Insolvency & Finance</h3>

                <p>
                  Banking and financial dispute resolution services
                  including recovery litigation, SARFAESI matters,
                  and cheque bounce actions.
                </p>

                <ul>
                  <li>
                    <i className="fas fa-check"></i>
                    Loan Recovery
                  </li>

                  <li>
                    <i className="fas fa-check"></i>
                    NI Act Matters
                  </li>

                  <li>
                    <i className="fas fa-check"></i>
                    SARFAESI Proceedings
                  </li>
                </ul>

                <a href="/services/banking-finance" className="service-btn">
                  Learn More <i className="fas fa-arrow-right"></i>
                </a>
              </ServiceContent>
            </ServiceCard>

            <ServiceCard
              onClick={() =>
                (window.location.href = "/services/labour-employment")
              }
            >
              <ServiceImage>
                <img
                  src="https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=1200&auto=format&fit=crop"
                  alt="Labour & Employment"
                />
              </ServiceImage>

              <ServiceContent>
                <h3>Labour & Employment</h3>

                <p>
                  Comprehensive employment law services including
                  HR advisory, labour disputes, compliance support,
                  and industrial tribunal representation.
                </p>

                <ul>
                  <li>
                    <i className="fas fa-check"></i>
                    Employment Contracts
                  </li>

                  <li>
                    <i className="fas fa-check"></i>
                    Labour Law Compliance
                  </li>

                  <li>
                    <i className="fas fa-check"></i>
                    Employee Disputes
                  </li>
                </ul>

                <a href="/services/labour-employment" className="service-btn">
                  Learn More <i className="fas fa-arrow-right"></i>
                </a>
              </ServiceContent>
            </ServiceCard>

            <ServiceCard
              onClick={() =>
                (window.location.href = "/services/real-estate")
              }
            >
              <ServiceImage>
                <img
                  src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=1200&auto=format&fit=crop"
                  alt="Real Estate"
                />
              </ServiceImage>

              <ServiceContent>
                <h3>Real Estate</h3>

                <p>
                  End-to-end real estate legal solutions for
                  transactions, leasing, financing, title disputes,
                  and property litigation matters.
                </p>

                <ul>
                  <li>
                    <i className="fas fa-check"></i>
                    Property Transactions
                  </li>

                  <li>
                    <i className="fas fa-check"></i>
                    Commercial Leases
                  </li>

                  <li>
                    <i className="fas fa-check"></i>
                    Title Disputes
                  </li>
                </ul>

                <a href="/services/real-estate" className="service-btn">
                  Learn More <i className="fas fa-arrow-right"></i>
                </a>
              </ServiceContent>
            </ServiceCard>

            <ServiceCard
              onClick={() =>
                (window.location.href = "/services/Arbitration")
              }
            >
              <ServiceImage>
                <img
                  src="/assets/family-dispute.jpg"
                  alt="Family-disputes"
                />
              </ServiceImage>

              <ServiceContent>
                <h3>Family Disputes</h3>

                <p>
                  Strategic Arbitration and dispute resolution services
                  including tribunal representation, enforcement of
                  awards, and settlement negotiations.
                </p>

                <ul>
                  <li>
                    <i className="fas fa-check"></i>
                    Loan Recovery & Financial Litigation
                  </li>

                  <li>
                    <i className="fas fa-check"></i>
                    NI Act Cheque Bounce & SARFAESI Matters
                  </li>

                  <li>
                    <i className="fas fa-check"></i>
                    Banking, NBFC Compliance & Asset Recovery
                  </li>
                </ul>

                <a href="/services/Arbitration" className="service-btn">
                  Learn More <i className="fas fa-arrow-right"></i>
                </a>
              </ServiceContent>
            </ServiceCard>

            
            <ServiceCard
              onClick={() =>
                (window.location.href = "/services/gst-returns")
              }
            >
              <ServiceImage>
                <img
                  src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=1200&auto=format&fit=crop"
                  alt="GST Services"
                />
              </ServiceImage>

              <ServiceContent>
                <h3>GST Services</h3>

                <p>
                  GST registration, returns filing, audits,
                  litigation support, tax planning, refunds,
                  and complete compliance advisory.
                </p>

                <ul>
                  <li>
                    <i className="fas fa-check"></i>
                    GST Registration
                  </li>

                  <li>
                    <i className="fas fa-check"></i>
                    GST Audits
                  </li>

                  <li>
                    <i className="fas fa-check"></i>
                    GST Litigation
                  </li>
                </ul>

                <a href="/services/gst-returns" className="service-btn">
                  Learn More <i className="fas fa-arrow-right"></i>
                </a>
              </ServiceContent>
            </ServiceCard>

            <ServiceCard
              onClick={() =>
                (window.location.href = "/services/trademark")
              }
            >
              <ServiceImage>
                <img
                  src="https://images.unsplash.com/photo-1521791055366-0d553872125f?q=80&w=1200&auto=format&fit=crop"
                  alt="Trademark & IP"
                />
              </ServiceImage>

              <ServiceContent>
                <h3>Trademark & IP</h3>

                <p>
                  Trademark registration, copyright protection,
                  opposition handling, licensing, and IP dispute
                  resolution services.
                </p>

                <ul>
                  <li>
                    <i className="fas fa-check"></i>
                    Trademark Registration
                  </li>

                  <li>
                    <i className="fas fa-check"></i>
                    Copyright Protection
                  </li>

                  <li>
                    <i className="fas fa-check"></i>
                    IP Enforcement
                  </li>
                </ul>

                <a href="/services/trademark" className="service-btn">
                  Learn More <i className="fas fa-arrow-right"></i>
                </a>
              </ServiceContent>
            </ServiceCard>
          </ServicesShowcase>

          <ViewAllServices>
            <a href="/services" className="view-all-btn">
              View All Services <i className="fas fa-arrow-right"></i>
            </a>
          </ViewAllServices>
        </ServicesContainer>
      </ServicesSection>

      {/* Practice Areas */}
        <PracticeAreasSection id="practice-areas">
        <div className="container">
          <PracticeGrid>

            <div className="practice-left-column">
              <div className="section-header">

                <span
                  className="section-tag"
                  style={{
                    background: "rgba(184,155,114,0.10)",
                    color: "#8B7355",
                    padding: "0.7rem 1.4rem",
                    borderRadius: "999px",
                    fontSize: "0.78rem",
                    letterSpacing: "0.12em",
                    textTransform: "uppercase",
                    fontWeight: "600",
                    display: "inline-block",
                    marginBottom: "1.5rem",
                    fontFamily: "Inter, sans-serif",
                  }}
                >
                  Practice Areas
                </span>

                <h2
                  className="section-title"
                  style={{
                    fontFamily:
                      '"Cormorant Garamond", Georgia, serif',
                    color: "#111827",
                    fontWeight: "500",
                    fontSize: "clamp(3rem, 5vw, 5rem)",
                    lineHeight: "1.05",
                    marginBottom: "1.5rem",
                    letterSpacing: "-1px",
                  }}
                >
                  Legal Solutions
                  <span
                    style={{
                      color: "#8B7355",
                      fontStyle: "italic",
                    }}
                  >
                    {" "}Across Industries
                  </span>
                </h2>

                <p
                  style={{
                    color: "#6B7280",
                    maxWidth: "520px",
                    lineHeight: "1.9",
                    fontSize: "1rem",
                    fontFamily: "Inter, sans-serif",
                  }}
                >
                  Delivering strategic legal advisory,
                  compliance solutions, dispute resolution,
                  and business-focused representation
                  across diverse sectors and practice areas.
                </p>

              </div>
            </div>

            <div className="practice-right-column">

              <PracticeItem href="/services/contract-law">

                <div className="practice-left">

                  <div className="practice-icon">
                    <i className="fas fa-file-signature"></i>
                  </div>

                  <div className="practice-content">
                    <h4>Contract Law</h4>

                    <p>
                      Drafting, review, negotiation,
                      compliance, and dispute resolution
                      for commercial and legal agreements.
                    </p>
                  </div>

                </div>

                <div className="practice-arrow">
                  <i className="fas fa-arrow-right"></i>
                </div>

              </PracticeItem>

              <PracticeItem href="/services/intellectual-property">

                <div className="practice-left">

                  <div className="practice-icon">
                    <i className="fas fa-lightbulb"></i>
                  </div>

                  <div className="practice-content">
                    <h4>Intellectual Property</h4>

                    <p>
                      Protection and enforcement of
                      trademarks, copyrights, patents,
                      and intellectual property rights.
                    </p>
                  </div>

                </div>

                <div className="practice-arrow">
                  <i className="fas fa-arrow-right"></i>
                </div>

              </PracticeItem>

              <PracticeItem href="/services/employment-law">

                <div className="practice-left">

                  <div className="practice-icon">
                    <i className="fas fa-users"></i>
                  </div>

                  <div className="practice-content">
                    <h4>Employment Law</h4>

                    <p>
                      Workplace disputes, employment
                      contracts, labor law compliance,
                      and HR-related legal advisory.
                    </p>
                  </div>

                </div>

                <div className="practice-arrow">
                  <i className="fas fa-arrow-right"></i>
                </div>

              </PracticeItem>

              <PracticeItem href="/services/international-law">

                <div className="practice-left">

                  <div className="practice-icon">
                    <i className="fas fa-globe"></i>
                  </div>

                  <div className="practice-content">
                    <h4>International Law</h4>

                    <p>
                      Cross-border transactions,
                      international business matters,
                      and global legal compliance support.
                    </p>
                  </div>

                </div>

                <div className="practice-arrow">
                  <i className="fas fa-arrow-right"></i>
                </div>

              </PracticeItem>

              <PracticeItem href="/services/environmental-law">

                <div className="practice-left">

                  <div className="practice-icon">
                    <i className="fas fa-leaf"></i>
                  </div>

                  <div className="practice-content">
                    <h4>Environmental Law</h4>

                    <p>
                      Environmental compliance,
                      regulatory approvals, legal advisory,
                      and sustainability-related matters.
                    </p>
                  </div>

                </div>

                <div className="practice-arrow">
                  <i className="fas fa-arrow-right"></i>
                </div>

              </PracticeItem>

              <PracticeItem href="/services/banking-finance">

                <div className="practice-left">

                  <div className="practice-icon">
                    <i className="fas fa-building-columns"></i>
                  </div>

                  <div className="practice-content">
                    <h4>Banking & Finance</h4>

                    <p>
                      Financial regulations, banking law,
                      securities matters, and strategic
                      financial legal advisory.
                    </p>
                  </div>

                </div>

                <div className="practice-arrow">
                  <i className="fas fa-arrow-right"></i>
                </div>

              </PracticeItem>

            </div>

          </PracticeGrid>
        </div>
      </PracticeAreasSection>

      {/* ISO Certificates Section */}
      <ISOCertificates />

      {/* Testimonials */}
      <TestimonialsSection />

      {/* Contact Section */}
      <ContactSection className="contact section" id="contact">
        <div className="container">
          <ContactContent>
            <ContactInfo>
              <div className="section-header">
                <span className="section-tag">Get In Touch</span>
                <h2 className="section-title">
                  Schedule Your{" "}
                  <span className="text-highlight" style={{
                    color: "#216b72"
                  }}>Free Consultation</span>
                </h2>
                <p className="section-description">
                  Ready to discuss your legal needs? Contact us today for a
                  comprehensive consultation with our experienced Consulting Team.
                </p>
              </div>

              <div className="contact-details">
                <div className="contact-item">
                  <div className="contact-icon">
                    <i className="fas fa-map-marker-alt"></i>
                  </div>
                  <div className="contact-text">
                    <h4>Office Address</h4>
                    <p>
                      U No. 386/310, 1st Floor, Street No. 16, Rithala Village
                      Delhi 110085
                    </p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">
                    <i className="fas fa-phone"></i>
                  </div>
                  <div className="contact-text">
                    <h4>Phone Number</h4>
                    <p>
                      +91 85068 74280
                      <br />
                      +91 93557 00507
                    </p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">
                    <i className="fas fa-envelope"></i>
                  </div>
                  <div className="contact-text">
                    <h4>Email Address</h4>
                    <p>mundraeximllp@gmail.com</p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">
                    <i className="fas fa-clock"></i>
                  </div>
                  <div className="contact-text">
                    <h4>Working Hours</h4>
                    <p>Mon - SAT: 10:00 AM - 6:00 PM</p>
                  </div>
                </div>
              </div>
            </ContactInfo>

            <ContactForm>
              <h3>Request Free Consultation</h3>
              <p>
                Get expert legal advice tailored to your needs. Fill out the
                form below and we'll get back to you within 24 hours.
              </p>

              <form onSubmit={handleFormSubmit}>
                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="firstName">
                      First Name <span className="required">*</span>
                    </label>
                    <div className="input-wrapper">
                      <span className="input-icon">
                        <i className="fas fa-user"></i>
                      </span>
                      <input
                        type="text"
                        id="firstName"
                        name="firstName"
                        placeholder="John"
                        required
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="lastName">
                      Last Name <span className="required">*</span>
                    </label>
                    <div className="input-wrapper">
                      <span className="input-icon">
                        <i className="fas fa-user"></i>
                      </span>
                      <input
                        type="text"
                        id="lastName"
                        name="lastName"
                        placeholder="Doe"
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="email">
                      Email Address <span className="required">*</span>
                    </label>
                    <div className="input-wrapper">
                      <span className="input-icon">
                        <i className="fas fa-envelope"></i>
                      </span>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        placeholder="john.doe@example.com"
                        required
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="phone">
                      Phone Number <span className="required">*</span>
                    </label>
                    <div className="input-wrapper">
                      <span className="input-icon">
                        <i className="fas fa-phone"></i>
                      </span>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        placeholder="+91 98765 43210"
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="legalMatter">
                    Select Legal Matter <span className="required">*</span>
                  </label>
                  <div className="input-wrapper">
                    <span className="input-icon">
                      <i className="fas fa-balance-scale"></i>
                    </span>
                    <select id="legalMatter" name="legalMatter" required>
                      <option value="">Choose your legal matter...</option>
                      <option value="corporate">
                        Corporate Law & Business Setup
                      </option>
                      <option value="civil">Civil Litigation & Disputes</option>
                      <option value="criminal">Criminal Defense</option>
                      <option value="family">Family Law & Matrimonial</option>
                      <option value="property">Property & Real Estate</option>
                      <option value="tax">Tax, GST & Compliance</option>
                      <option value="labor">Labor & Employment Law</option>
                      <option value="ipr">Intellectual Property Rights</option>
                      <option value="other">Other Legal Matter</option>
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="message">
                    Describe Your Legal Matter{" "}
                    <span className="required">*</span>
                  </label>
                  <div className="input-wrapper">
                    <span className="input-icon">
                      <i className="fas fa-comment-dots"></i>
                    </span>
                    <textarea
                      id="message"
                      name="message"
                      placeholder="Please provide details about your legal concern so we can better assist you..."
                      rows="5"
                      required
                    />
                  </div>
                </div>

                <button type="submit" className="submit-btn">
                  <i className="fas fa-calendar-check"></i>
                  <span>Schedule Free Consultation</span>
                  <i className="fas fa-arrow-right"></i>
                </button>

                <div className="form-note">
                  <i className="fas fa-lock"></i>
                  Your information is confidential and secure
                </div>
              </form>
            </ContactForm>
          </ContactContent>
        </div>
      </ContactSection>

      {/* Footer */}
      <Footer />

      {/* Back to Top Button */}
      {/* <BackToTop
        className={showBackToTop ? "visible" : ""}
        onClick={scrollToTop}
      >*/}
      <i className="fas fa-chevron-up"></i>
      {/* </BackToTop>*/}
    </AppContainer>
  );

  return (
    <Router>
  <GlobalStyles />
  {/* Render Chatty assistant globally above the WhatsApp CTA */}
  <ChattyAssistant />
  <WhatsAppFloatingButton />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<About />} />
  <Route path="/terms" element={<Terms />} />
  <Route path="/privacy" element={<Privacy />} />
    <Route path="/sitemap" element={<Sitemap />} />
       {/* <Route path="/events" element={<Events />} /> */}
        <Route path="/services" element={<HomePage />} />
        <Route path="/contact" element={<ContactUs />} />
        {/* Service routes + aliases for navigation compatibility */}
        <Route path="/services/lease-deed" element={<LeaseDeed />} />
        <Route
          path="/services/stamp-paper-notary"
          element={<StampPaperNotary />}
        />
        <Route
          path="/services/property-registry"
          element={<PropertyRegistry />}
        />
        <Route
          path="/services/contract-drafting"
          element={<ContractDrafting />}
        />
        <Route
          path="/services/relationship-certificate"
          element={<RelationshipCertificate />}
        />
        <Route path="/services/court-marriage" element={<CourtMarriage />} />
        <Route path="/services/legal-notices" element={<LegalNotices />} />
        <Route
          path="/services/franchise-agreement"
          element={<FranchiseAgreement />}
        />
        <Route path="/services/certified-copy" element={<CertifiedCopy />} />
        {/* private-limited alias */}
        <Route path="/services/private-limited" element={<PrivateLimitedCompany />} />
        <Route path="/services/private-limited-company" element={<PrivateLimitedCompany />} />
        {/* public-limited alias */}
        <Route path="/services/public-limited" element={<PublicLimitedCompany />} />
        <Route path="/services/public-limited-company" element={<PublicLimitedCompany />} />
        <Route
          path="/services/opc-proprietorship"
          element={<OpcAndProprietorship />}
        />
        {/* nbfc alias */}
        <Route path="/services/nbfc" element={<NbfcRegistration />} />
        <Route path="/services/nbfc-registration" element={<NbfcRegistration />} />
        <Route path="/services/society-trust" element={<SocietyAndTrust />} />
        {/* gst-returns aliases */}
        <Route path="/services/gst-returns" element={<GstRegistrationAndReturns />} />
        <Route path="/services/gst-registration-returns" element={<GstRegistrationAndReturns />} />
        <Route path="/services/itr-filing" element={<ItrFiling />} />
        {/* annual-filing aliases */}
        <Route path="/services/annual-filing" element={<AnnualFilingAndRoc />} />
        <Route path="/services/annual-filing-roc" element={<AnnualFilingAndRoc />} />
        <Route
          path="/services/bookkeeping-audit"
          element={<BookKeepingAndAudit />}
        />
        {/* trademark aliases */}
        <Route path="/services/trademark" element={<TrademarkRegistration />} />
        <Route path="/services/trademark-registration" element={<TrademarkRegistration />} />
        <Route
          path="/services/copyright-registration"
          element={<CopyrightRegistration />}
        />
        <Route path="/services/patent-filing" element={<PatentFiling />} />
        {/* fssai alias */}
        <Route path="/services/fssai" element={<FssaiLicense />} />
        <Route path="/services/fssai-license" element={<FssaiLicense />} />
        <Route path="/services/trade-license" element={<TradeLicense />} />
        <Route
          path="/services/import-export-code"
          element={<ImportExportCode />}
        />
        {/* iso alias */}
        <Route path="/services/iso-certificate" element={<IsoCertification />} />
        <Route path="/services/iso-certification" element={<IsoCertification />} />
        <Route path="/services/legal-metrology" element={<LegalMetrology />} />
        <Route path="/services/epr-certificate" element={<EprCertificate />} />
        <Route path="/services/bis-hallmark" element={<BisHallmark />} />
        {/* psara alias */}
        <Route path="/services/psara" element={<PsaraLicense />} />
        <Route path="/services/psara-license" element={<PsaraLicense />} />
        <Route path="/services/wpc-vno" element={<WpcVno />} />
        <Route path="/services/bpo-license" element={<BpoLicense />} />
        <Route
          path="/services/apeda-registration"
          element={<ApedaRegistration />}
        />
        {/* Import license for medical devices (MD-14 & MD-15) */}
        <Route
          path="/services/import-medical-devices"
          element={<ImportMedicalDevices />}
        />
        <Route
        path="/services/section-19-legal-metrology" element= {<Section19/>} />

        <Route
          path="/services/permission-to-import-medical-devices"
          element={<ImportMedicalDevices />}
        />
        <Route 
        path="/services/gem-registration" element= {<GemRegistration/>}/>
        
        <Route
          path="/services/form-md-14-md-15"
          element={<ImportMedicalDevices />}
        />
        <Route path="/services/bail-matters" element={<BailMatters />} />
        {/* cyber-fraud alias */}
        <Route path="/services/cyber-fraud" element={<CyberFraud />} />
        <Route path="/services/call-centre-crime" element={<CyberFraud />} />
        <Route path="/services/civil-criminal" element={<CivilAndCriminal />} />
        <Route
          path="/services/arbitration"
          element={<Arbitration />}
        />
        <Route
          path="/services/consumer-complaint"
          element={<ConsumerComplaint />}
        />
        <Route path="/services/criminal-cases" element={<CriminalCases />} />
        <Route
          path="/services/document-attestation"
          element={<DocumentAttestation />}
        />
        {/* new route for litigation alias */}
        <Route path="/services/litigation" element={<LitigationServices />} />
        {/* Additional service routes */}
        <Route path="/services/notarization" element={<Notarization />} />
        <Route path="/services/loan-project-reports" element={<LoanProjectReports />} />
        <Route path="/services/shifting-registered-office" element={<ShiftingRegisteredOffice />} />
        <Route path="/services/shift-registered-office" element={<ShiftingRegisteredOffice />} />
        <Route path="/services/website-development" element={<WebsiteDevelopment />} />
        <Route path="/services/ecommerce-development" element={<EcommerceDevelopment />} />
        <Route path="/testimonials" element={<HomePage />} />
      </Routes>
    </Router>
  );
}

export default App;
